import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { TutorialesComponent } from './components/tutoriales/tutoriales.component';
import { EstudiosComponent } from './components/estudios/estudios.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { HomeComponent } from './components/home/home.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { BlogComponent } from './components/blog/blog.component';
import { PruebaComponent } from './components/prueba/prueba.component';
import { TarjetaComponent } from './components/tarjeta/tarjeta.component';
import { ProyectosComponent } from './components/proyectos/proyectos.component';

import { ROUTES } from './app.routes';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HabilidadesComponent } from './components/habilidades/habilidades.component';
import { AboutMeComponent } from './components/about-me/about-me.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    TutorialesComponent,
    EstudiosComponent,
    GaleriaComponent,
    ContactoComponent,
    HomeComponent,
    FooterComponent,
    BlogComponent,
    PruebaComponent,
    TarjetaComponent,
    ProyectosComponent,
    HabilidadesComponent,
    AboutMeComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(ROUTES, {useHash: true}),
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
